module.exports = __webpack_public_path__ + "static/media/dragon4.5f24778a.png";